import { navPanel, closeNav } from './nav'

export function initViewTransitions() {
  window.addEventListener('pageswap', (event) => {
    const destinationUrl = event.activation?.entry?.url

    if (!destinationUrl) return
    if (event.viewTransition && new URL(destinationUrl).hash) event.viewTransition.skipTransition()

    // Close the mobile nav with transitions disabled so the outgoing header
    // snapshot matches the incoming (closed) header — otherwise the open panel
    // flashes during the view transition when navigation outruns the close.
    navPanel?.style.setProperty('transition', 'none')
    closeNav()
  })
}
